import React from 'react';
import { MinusIcon, PlusIcon, XIcon } from 'lucide-react';
import { CartItem as CartItemType } from '../context/CartContext';
import { useCart } from '../context/CartContext';
interface CartItemProps {
  item: CartItemType;
}
export const CartItem: React.FC<CartItemProps> = ({
  item
}) => {
  const {
    updateQuantity,
    removeItem
  } = useCart();
  return <div className="flex py-4 border-b border-gray-200 last:border-b-0" data-id="element-41">
      <div className="h-20 w-20 flex-shrink-0 overflow-hidden rounded-md border border-gray-200" data-id="element-42">
        <img src={item.image} alt={item.name} className="h-full w-full object-cover object-center" data-id="element-43" />
      </div>
      <div className="ml-4 flex flex-1 flex-col" data-id="element-44">
        <div className="flex justify-between text-base font-medium text-gray-900" data-id="element-45">
          <h3 data-id="element-46">{item.name}</h3>
          <p className="ml-4" data-id="element-47">${(item.price * item.quantity).toFixed(2)}</p>
        </div>
        <p className="mt-1 text-sm text-gray-500" data-id="element-48">Size: {item.size}</p>
        <div className="flex flex-1 items-end justify-between text-sm" data-id="element-49">
          <div className="flex items-center" data-id="element-50">
            <button onClick={() => updateQuantity(item.id, item.quantity - 1)} className="p-1 text-gray-400 hover:text-gray-500" aria-label="Decrease quantity" data-id="element-51">
              <MinusIcon size={16} data-id="element-52" />
            </button>
            <span className="mx-2 w-8 text-center text-gray-700" data-id="element-53">
              {item.quantity}
            </span>
            <button onClick={() => updateQuantity(item.id, item.quantity + 1)} className="p-1 text-gray-400 hover:text-gray-500" aria-label="Increase quantity" data-id="element-54">
              <PlusIcon size={16} data-id="element-55" />
            </button>
          </div>
          <button type="button" onClick={() => removeItem(item.id)} className="font-medium text-fuchsia-600 hover:text-fuchsia-500 flex items-center" data-id="element-56">
            <XIcon size={16} className="mr-1" data-id="element-57" />
            Remove
          </button>
        </div>
      </div>
    </div>;
};